import GroupedBarChart from '@common-components/graphs/group-bar-graph/GroupedBarChart';
import StandardBarVolume from '@common-components/graphs/standard-bar-graph/StandardBarVolume';
import React from 'react'
import {  useParams, useSearchParams } from 'react-router-dom';

export default function WeightGraph() {
    const params = useParams()
    const [searchParams] = useSearchParams();
    const batchId = searchParams.get("batchID");
    const startDate = searchParams.get("startDate");
    const endDate = searchParams.get("endDate");
    const filter = searchParams.get("filter"); 
    return (
        <div className='mt-10'>
            <StandardBarVolume type="full" supplierID={params.id} batchId = {batchId} sDate = {startDate} endDate = {endDate} filter = {filter} />

        </div>
    )
}
